export default __webpack_public_path__ + "static/media/dwight-school-seoul.1c068227.png";